import React from 'react';
import PropTypes from 'prop-types';

import { Grid } from '@mui/material';

import DateTimeInputMaskedField from '../../views/timekeeping/timekeepingGridView/DateTimeInputMaskedField';

import { PunchInputGrid } from './Styles/PunchPickerStyles';

const FormPunchSetField = ({ punchData, handlePunchChange }) => {
  const punchInputOnChange = (value, punchInOut) => {
    const newPunchData = { ...punchData, [punchInOut]: { stamp: value } };

    handlePunchChange([newPunchData]);
  };

  return (
    <PunchInputGrid container item spacing={1}>
      <Grid item xs={6}>
        <DateTimeInputMaskedField
          label="Clock In"
          value={punchData?.in?.stamp ? new Date(punchData?.in?.stamp) : null}
          onChange={(value) => punchInputOnChange(value, 'in')}
        />
      </Grid>

      <Grid item xs={6}>
        <DateTimeInputMaskedField
          label="Clock Out"
          value={punchData?.out?.stamp ? new Date(punchData?.out?.stamp) : null}
          onChange={(value) => punchInputOnChange(value, 'out')}
        />
      </Grid>
    </PunchInputGrid>
  );
};

FormPunchSetField.propTypes = {
  punchData: PropTypes.shape({
    in: PropTypes.shape({ stamp: PropTypes.number }),
    out: PropTypes.shape({ stamp: PropTypes.number }),
  }),

  handlePunchChange: PropTypes.func,
};

export default FormPunchSetField;
